import axios from "axios";
import CryptoJS from "crypto-js";
import uuidv1 from "uuid/v1";
const api = axios.create({
  baseURL: "https://ir.orvibo.com"
});

const appId = "web";
const appkey = "003e6fe600144509bf79b7382a3d97e6";
const source = "aligenie-h5";
/**
 * 生成通用参数
 */
const createParams = () => {
  const sn = uuidv1();
  const sign = CryptoJS.HmacSHA1(sn, appkey).toString();
  return {
    source,
    appId,
    sn,
    sign
  };
};

/**
 *  获取品牌列表
 * @param deviceType 设备类型   1:机顶盒 2:电视 3:网络盒子 4:DVD 5:空调 6:投影仪 7:功放 8:风扇 9:单反相机 10:开关灯泡 11:空气净化器 12:热水器
 * @param countryCode 国家代码
 * @param lanCode  语言代码
 * @param m 请求分类
 * @example m=getBrands&deviceType=2&countryCode=CN&lanCode=zh
 */

export const getBrandList = params => {
  return api
    .get(`/service?m=getBrands`, {
      params: {
        ...params,
        ...createParams()
      }
    })
    .then(res => res.data);
};
/**
 * 机顶盒-获取城市信息
 * @param p 省
 * @param c 市
 * @param a 去
 * @param m 请求分类
 * @example m=getCity&p=山东省&c=青岛市&c=崂山区
 */
export const getAreaId = params => {
  return api
    .get(`/service?m=getCity`, {
      params: {
        ...params,
        ...createParams()
      }
    })
    .then(res => res.data);
};

/**
 * 机顶盒-获取机顶盒红外列表
 * @param spId 省
 * @param cityId 市
 * @param m 请求分类
 * @example m=getSTBRemoteId
 */
export const getSTBRemoteIds = params => {
  return api
    .get(`/service?m=getSTBRemoteIds`, {
      params: {
        ...params,
        ...createParams()
      }
    })
    .then(res => res.data);
};
/**
 * 机顶盒-获取IPTV红外列表
 * @param brandId 品牌Id
 * @param m 请求分类
 * @example m=getIPTVRemoteIds
 */
export const getIPTVRemoteIds = params => {
  return api
    .get(`/service?m=getIPTVRemoteIds`, {
      params: {
        ...params,
        ...createParams()
      }
    })
    .then(res => res.data);
};
/**
 * 机顶盒-获取运营商列表
 * @param m 请求分类
 * @param cityId 城市Id
 * @example m=getSPList&cityId=110100
 */
export const getOperationList = params => {
  return api
    .get(`/service?m=getSPList`, {
      params: {
        ...params,
        ...createParams()
      }
    })
    .then(res => res.data);
};

/**
 * 机顶盒-运营商类型为IPTV
 * @param spId 运营商ID
 * @param m 请求类型
 * @example m=getIPTVBrandList&spId=22
 */

export const getIPTVIRList = params => {
  return api
    .get(`/service?m=getIPTVBrandList`, {
      params: {
        ...params,
        ...createParams()
      }
    })
    .then(res => res.data);
};

/**
 *获取红外列表
 *@param rids 红外码ID
 *@param m 请求分类
 *@example m=getIr&rid=147,152,157
 */

export const getIrs = params => {
  return api
    .get(`/service?m=getMKeys&countryCode=CN&lanCode=zh`, {
      params: {
        ...params,
        ...createParams()
      }
    })
    .then(res => res.data);
};

/**
 *  获取红外Id列表(红外Id列表1/3-非机顶盒)
 * @param deviceType 设备类型 1:机顶盒,2:电视,3:网络盒子,4:DVD,5:空调,6:投影仪,7:功放,8:风扇,9:单反相机,10:开关灯泡,11:空气净化器,12:热水器
 * @param brandId 品牌id
 * @param m 请求分类
 * @param countryCode 国家代码
 * @example
 *
 */

export const getRemoteIdList = params => {
  return api
    .get(`/service?m=getRemoteIds&countryCode=CN`, {
      params: {
        ...params,
        ...createParams()
      }
    })
    .then(res => res.data);
};

/**
 * 空调-获取空调红外
 * @param m 请求分类
 * @param rid 红外id
 * @param  action 功能,["query":功能1,"send":功能2]
 * @param  power 开关机状态 开机：0，关机：1“”
 * @param  mode 模式  “制冷：0，制热：1，自动：2，送风：3，除湿：4”
 * @param  temp 温度,如果没法设置温度，请传入-1或者不传 “16度-30度”
 * @param  speed 风量,如果没法设置风量，请传入-1或者不传 “自动：0，低：1，中：2，高：3”
 * @param  direct 风向   “扫风：0， 固定风1-n”   ”如果是只有0表示没有风向，只有1表示不区分扫风和固定风“
 * @param  fid 按键id  ”电源：1,模式：2，温度+：3，温度-：4，风量：5，扫风：6，固定风：7”
 * @example 功能1:m/acir?action=query&rid=2607
 功能2:m=getAcIrByStatus&rid=2607&action=send&power=0&mode=0&temp=26&speed=0&direct=0&fid=4
 */

export const getAirIrs = params => {
  return api
    .get(`/service?m=getAcIrByStatus`, {
      params: {
        ...params,
        ...createParams()
      }
    })
    .then(res => res.data);
};



// WEBPACK FOOTER //
// ./src/api/kookong.js